/**
 * Extracts the TAL form key (e.g. "TAL_102A_E") from a TAL PDF URL.
 * Returns `null` if the URL is missing or doesn't contain a TAL filename.
 */
export function extractTalKeyFromUrl(url?: string | null): string | null {
  if (!url) return null;
  try {
    const pathname = new URL(url).pathname;
    const filename = pathname.split('/').pop() || '';
    const key = filename.replace(/\.pdf$/i, '');
    return key && key.startsWith('TAL') ? key : null;
  } catch {
    return null;
  }
}

/**
 * Given a form with a `key` and optional `url` map, return the best key to use
 * for the AI-fill catalog (TAL code preferred, kebab-case key as fallback).
 */
export function getFormCatalogKey(form: {
  key: string;
  url?: { en?: string; fr?: string } | null;
}): string {
  return (
    extractTalKeyFromUrl(form.url?.en) ??
    extractTalKeyFromUrl(form.url?.fr) ??
    form.key
  );
}
